import React from "react";
import { useContent } from "@thoughtbot/superglue";

type DemoContent = {
  message: string;
  nextPath: string;
};

export default function Goodbye() {
  const { message, nextPath } = useContent<DemoContent>();

  return (
    <main id="superglue-demo">
      <h1>{message}</h1>
      <a href={nextPath} data-sg-visit="true">
        Return to the first demo page
      </a>
    </main>
  );
}
